(function($) {
    var items = $('.module-faq-item');
    var hash = window.location.hash;
    items.each(function(index, item) {
        $(item).on('click', function(event) {
            event.preventDefault();
            $(item).toggleClass('--is-open');
        })
    })

    if(hash.length > 1) {
        var hashItem = $(hash);
        $(hashItem).addClass('--is-open');
    }
}(jQuery))